// The two legal documents the web client points at, in one place. Neither is
// served by this app: the old web app rendered its own copy of the privacy policy
// at /privacy-policy, and darwin_core carried the same text plus the terms as
// `legalPolicies` — a 2019 snapshot that went stale and has now been removed. The
// hosted pages are the only version anyone should be reading, so every surface
// here links out to them.

// The document the mobile app's sign-up screen puts behind its "I agree to the
// Terms & Conditions" tick (app/src/screens/Auth/SignUp.js), so it is what an
// account holder actually agreed to.
//
// The app's terms-review overlay links a DIFFERENT page — TERMS_AND_CONDITIONS_LINK
// in darwin_core/utils/consts.js, which resolves to Ideal's "Link App Terms &
// Conditions" (the Link Pro installer app, not Halo). Web deliberately does not
// follow that one. Ideal publishes no Halo-app terms page at all yet; when it
// does, this is the single line to change.
export const TERMS_URL = 'https://idealheating.com/terms-conditions';

// The Halo-specific privacy notice — also where /privacy-policy has forwarded
// since the web refresh (see screens/PrivacyPolicy.jsx).
export const PRIVACY_URL = 'https://idealheating.com/halo-app-privacy-notice';

// The pair, named and ordered as the app's sign-up screen names them, for the two
// surfaces that offer both: the Legal screen and the signed-out footer. The
// privacy document is called "Privacy Notice" after its own title (the app's
// sign-up line says "Privacy Statement", which names nothing that exists).
export const LEGAL_DOCUMENTS = [
  { title: 'Terms & Conditions', href: TERMS_URL },
  { title: 'Privacy Notice', href: PRIVACY_URL },
];
